import React from 'react';
import Breadcrumb from '../components/ShearedComponents/Breadcrumb';
import Summary from "../components/checkout/Summary";

const Checkout = () => {
    return (
        <div className='bg-gray-100 pb-4'>
            <div className='c container mx-auto'>
                <Breadcrumb page="Checkout" />
                <Summary />
            </div>
        </div>
    );
};

export default Checkout;